


















import { Component, Vue, Watch } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
// import checkLogin from '../../utils/checkLogin';
import { Debounced } from '../../utils/debounced';
@Component({
  components: {
    Loading,
  },
})
export default class Test extends Vue {
  private user: any;
  private last: number = 0; // 延迟搜索
  private spinning = false;
  private Keyword: string = '';
  private dataSource: any = [];
  private debouncedUse: (...args: any[]) => any =  new Debounced().use(this.pullDataSource, 1000);
  private  mounted() {
    this.user = storage.get('user');
    if (this.user) {
      // checkLogin();
      // this.getData();
    } else {
    this.$router.push({
        path: '/login',
      });
    }
  }
  // @Watch('value')
  // private value1(val: string) {
  //   console.log('value', val);
  // }
  private async onSearch(searchText: string) {
    this.debouncedUse(searchText);
  }
  private async pullDataSource(searchText: string) {
    const data: any = await this.getDataSource(searchText);
    const arr: any = [];
    if (data.length > 0) {
      data.forEach((element: any, index: number) => {
        arr.push(element.productName);
      });
      this.dataSource = arr;
    }
  }
  private onSelect(value: string) {
    console.log('onSelect', value);
  }
  private onChange(value: string) {
    console.log('onChange', value);
  }
  private getDataSource(Keyword: string) {
    return new Promise((resolve, reject) => {
      this.spinning = true;
      const that = this;
      const url = '/api/getPmInfoLike';
      const args = {
        pmName: '家伟',
        Keyword,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          console.log(res.data.data);
          resolve(res.data.data);
          // that.dataSource = res.data.data;
          this.spinning = false;
        }
      });
    });
  }
}
